module.exports = __webpack_public_path__ + "static/media/filter.f95e692a.jpg";